import { render, staticRenderFns } from "./newSwiper.vue?vue&type=template&id=98c888c8&"
import script from "./newSwiper.vue?vue&type=script&lang=js&"
export * from "./newSwiper.vue?vue&type=script&lang=js&"
import style0 from "./newSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports